import React, { useState, useEffect } from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from './ThemeProvider';
import { Button } from './ui/button';
import { useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
  const { isDarkMode, toggleTheme } = useTheme();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    // Check if we're on the home page
    if (location.pathname !== '/') {
      // Navigate to home page with hash
      navigate(`/#${sectionId}`);
      return;
    }
    
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navigateToAI = () => {
    // Navigate to AI page using React Router
    navigate('/ai');
    setIsMobileMenuOpen(false); // Close mobile menu
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleNavClick = (action) => {
    action();
    setIsMobileMenuOpen(false); // Close mobile menu after navigation
  };

  // navigateToAI function moved above

  return (
    <header className={`header-container ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-wrapper">
        <div className="header-content-new">
          <div className="header-left">
            <button 
              className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
              onClick={toggleMobileMenu}
            >
              <div className="hamburger-line"></div>
              <div className="hamburger-line"></div>
              <div className="hamburger-line"></div>
            </button>
          </div>
          
          <div className="header-slogan-vertical">
            <div className="slogan-protect">Protect</div>
            <div className="slogan-trust">Trust</div>
            <div className="slogan-innovate">Innovate</div>
          </div>
          
          <nav className={`navigation-center ${isMobileMenuOpen ? 'mobile-menu-open' : ''}`}>
            <button 
              onClick={() => handleNavClick(() => scrollToSection('services'))} 
              className="nav-link nav-link-blue"
            >
              Consultancy Services
            </button>
            <button 
              onClick={() => handleNavClick(navigateToAI)} 
              className="nav-link nav-link-green"
            >
              AI Products
            </button>
            <button 
              onClick={() => handleNavClick(() => scrollToSection('contact'))} 
              className="nav-link nav-link-grey"
            >
              Contact
            </button>
          </nav>
          
          <div className="header-right">
            <Button
              onClick={toggleTheme}
              variant="secondary"
              size="sm"
              className="theme-toggle"
            >
              {isDarkMode ? <Sun size={16} /> : <Moon size={16} />}
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;